export interface IModel {
    id: string;
    name: string;
    description: string;
    category: "Anthropic";
}

export const MODELS: IModel[] = [
    {
        id: "us.anthropic.claude-opus-4-6-v1",
        name: "Claude Opus 4.6",
        description: "Deep Thinking",
        category: "Anthropic",
    },
    {
        id: "us.anthropic.claude-sonnet-4-6",
        name: "Claude Sonnet 4.6",
        description: "General Usage",
        category: "Anthropic",
    },
    {
        id: "us.anthropic.claude-haiku-4-5-20251001-v1:0",
        name: "Claude Haiku 4.5",
        description: "Fast Response",
        category: "Anthropic",
    },
];

export const DEFAULT_MODEL_ID = "us.anthropic.claude-sonnet-4-6";

export const getModelById = (id: string): IModel | undefined => {
    return MODELS.find((model) => model.id === id);
};

export const getModelName = (id: string): string => {
    const model = getModelById(id);
    return model?.name || id;
};
